import { styled as n } from "@lokalise/styled";
import { spacing as o } from "../../utils/theme/index.js";
const d = n.div`
	padding: ${({ $padding: i }) => o(...i)}; // Uses padding instead of margin to avoid margin collapse issue.

	// Will not display if there are no children
	&:empty {
		display: none;
	}
`;
export {
  d as Container
};
//# sourceMappingURL=styles.js.map
